import { ProgramNames } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'

export const DA_FLEXIBLE_NOTE_NAME = 'daFlexibleNote'

type TherapyType = 'Individual' | 'Couple' | 'Family'

export const PROGRAM_TO_THERAPY_TYPE: Partial<Record<ProgramNames, TherapyType>> = {
  [ProgramNames.DirectAccessIndividualTherapy]: 'Individual',
  [ProgramNames.DirectAccessIndividualChildTherapy]: 'Individual',
  [ProgramNames.DirectAccessIndividualAdolescentTherapy]: 'Individual',
  [ProgramNames.DirectAccessCouplesTherapy]: 'Couple',
  [ProgramNames.DirectAccessFamilyTherapy]: 'Family',
}

export const FLEX_NOTE_EPISODE_CLOSURE_FIELDS = new Set([
  'is_last_session',
  'dischargeWarningBanner',
  'episode_state',
  'termination_comment',
])

export const FLEX_NOTE_CLOSE_SESSION_READONLY_FIELDS: string[] = [
  'sessionDetails',
  'sessionDetailsDescription',
  'attendance',
  'changeReason',
  'technicalIssuesCancelSelection',
  'technicalIssuesCancelDetails',
  'otherChangeReason',
  'changeNotice',
  'modality',
  'session_duration',
  'therapyType',
  'therapyTypeInfo',
  'attendeesNumberPresent',
  'reference_number',
  'sessionRateMessage',
  'sessionRateMessageInEligible',
  'diagnosisAndTreatmentHeader',
  'diagnosisAndTreatmentDescription',
  'primary_condition',
  'other_primary_description',
  'secondary_condition',
  'other_secondary_description',
  'primaryDiagnosisArticleInfo',
  'icd10_primary_diagnosis',
  'icd10_secondary_diagnosis',
  'guardianConsent',
  'is_last_session',
  'dischargeWarningBanner',
  'episode_state',
  'termination_comment',
  'approachingSpecialityCare',
  'preAuthInfo',
  'attestation_pre_authorization',
  'attestation_data.noteAppropriateSections_4',
  'attestation_data.doesClientHigh_6_1',
  'attestation_data.highRiskFactors',
  'attestation_data.highRiskFactorsTreatment',
  'attestation_data.otherHighRiskFactors',
  'attestation_data.otherHighRiskFactorsTreatment',
  'attestation_data.doesClientHigh_6_2',
  'attestation_data.activeSubstanceAbuseTypes',
  'attestation_data.activeSubstanceAbuseTreatment',
  'attestation_data.activeSubstanceAbuseTreatmentDescription',
  'attestation_data.hasPersistentMentalHealthCondition',
  'attestation_data.hasPersistentMentalHealthConditionType',
  'attestation_data.hasHighPhqGadScoreContent',
  'attestation_data.hasHighPhqGadScore',
  'attestation_data.hasPersistentMentalHealthConditionTreatment',
  'attestation_data.hasPersistentMentalHealthConditionDescription',
]
